import React, { useContext } from 'react';
import styled from 'styled-components';
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import 'moment/locale/pt-br';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  width: calc(33% - 16px);
  @media (max-width: 789px) {
    min-width: calc(50% - 8px);
    margin-right: 16px;
  }
  @media (max-width: 540px) {
    min-width: 100%;
  }
  a {
    display: block;
    text-decoration: none;
    .image {
      display: flex;
      width: 100%;
      height: 250px;
      border-bottom: 6px solid #6A7B43;
      border-radius: 3px;
      background: #BDBDBD;
      overflow: hidden;
      position: relative;
      span {
        height: 100%;
        width: 100%;
        transition: all 0.3s;
        background-position: center;
        background-size: cover;
      }
    }
    &:hover {
      .image span {
        transform: scale(1.05);
      }
    }
    strong {
      display: block;
      margin-top: 14px;
      font: bold 20px Montserrat;
      color: #2D2D2C;
    }
    p {
      font: 14px Montserrat;
      color: #2D2D2C;
      margin: 14px 0 0;
    }
    small {
      color: #545454;
      font: 12px Montserrat;
      margin-top: 20px;
      display: block;
    }
  }
`;

const Play = styled.div`
  position: absolute;
  width: 67px;
  height: 67px;
  bottom: 10px;
  left: 10px;
  background: url(/images/play.png) no-repeat center;
  background-size: contain;
`;

const RelatedItem = ({titulo, uid, banner, categoria, subtitulo, data}) => {
  const { language } = useContext(LanguageContext);
  return (
    <Container>
      <Link to={ `/conteudo/${uid}` }>
        <span className="image">
          <span style={ { backgroundImage: `url(${banner.url})`}}></span>
          {
            categoria.slug === 'videos' && (
              <Play />
            )
          }
        </span>
        <strong>
          { titulo[0].text }
        </strong>
        <p>
          { subtitulo[0].text }
        </p>
        <small>
          <Moment format={ 'LL' } locale={ language }>
            { data }
          </Moment>
        </small>
      </Link>
    </Container>
  );
}

export default RelatedItem;
